const { createSlice } = require("@reduxjs/toolkit");

const productsSlice=createSlice({
    name:'products',
    initialState:{
        editProduct:null
    },
    reducers:{
        setEditProductDetails(state,action){
            state.editProduct=action.payload
        },
    }
})

export const productsActions=productsSlice.actions;
export default productsSlice;